'use client';

import styled, { css } from 'styled-components';
// import ArrowImgUp from '@/images/icon/arrow-up.png';
// import ArrowImgDown from '@/images/icon/arrow-down.png';
// import ArrowImgRight from '@/images/icon/arrow-right.png';
import StarImg from '@/images/icon/full-star.png';
import AddCartImg from '@/images/icon/add-cart.png';
import PlayLittleIcon from '@/images/icon/play-little-icon.png';
import FavoriteIcon from '@/images/icon/favorite.png';
// import FavoriteIcon2 from '@/images/icon/favorite-icon-2.png';
// import FavoriteIcon3 from '@/images/icon/follow-hover.png';
// Define mixins -- start ---
export const imgMask = css`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 55;
    background: rgba(0, 0, 0, 0.02);
    pointer-events: none; // 避免影响点击播放
  }
`;

const line2Overflow = css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
// Define mixins -- end ---

export const ProductLayoutWrapper = styled.div`
  .product {
    &-layout {
      width: 1264px;
      margin: 0 auto;
    }
  }

  .alert-style-set {
    width: 100%;
    height: 36px;
    background-color: rgba(255, 248, 234, 1);
  }

  .alert-style {
    padding-left: 0;
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 1264px;
    height: 36px;
    color: rgba(201, 146, 39, 1);
    border: 0;
  }
`;
export const BreadcrumbsWrapper = styled.div`
  width: 0;
  flex: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const HeaderNavWrapper = styled.nav`
  padding: 32px 0;
  display: flex;
  justify-content: space-between;
  gap: 60px;
  .product {
    &-nav-share {
      display: flex;
      gap: 16px;
      align-items: center;
      min-width: 126px;
      & > span {
        font-size: 14px;
        color: var(--sys-Text-Tertiary);
      }
    }
    &-social-share {
      cursor: pointer;
      height: 18px;
      width: 18px;
    }
  }
`;

export const MainWrapper = styled.main`
  display: flex;
  gap: 16px;
  /* margin-bottom: 32px; */
  .product {
    &-column-1 {
      width: 752px;
    }

    &-column-2 {
      width: 496px;
      padding: 0 16px;
    }
  }
`;

export const ImageShowWrapper = styled.section`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  user-select: none;
  .media-content {
    position: relative;
    width: 624px;
    height: 624px;
  }
  .product {
    &-thumbnails-list {
      padding: 2px 0;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      gap: 16px;
      width: 112px;
      height: 624px;
      overflow-y: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      align-items: center;
      &:-webkit-scrollbar {
        display: none;
      }
    }

    &-thumbnail {
      cursor: pointer;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      flex-shrink: 0;
      width: 108px;
      height: 108px;
      padding: 2px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 2px;
      }
      .player-tag-icon {
        position: absolute;
        left: 8px;
        top: 8px;
        border-radius: 2px;
        line-height: 17px;
        background: rgba(0, 0, 0, 0.25) url('${PlayLittleIcon.src}') no-repeat 6px 5px;
        background-size: 6px 8px;
        color: #fff;
        padding-left: 14px;
        padding-right: 6px;
        font-size: 10px;
      }
      &.active {
        outline: 2px solid #1a1a1a;
      }

      ${imgMask}
      border-radius: 8px;
    }

    &-big-img {
      width: 624px;
      height: 624px;
      border-radius: 2px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      ${imgMask}

      .favorite {
        position: absolute;
        z-index: 66;
        top: 12px;
        right: 12px;
        width: 48px;
        height: 48px;
        background: url('${FavoriteIcon.src}') no-repeat;
        background-size: 48px 48px;
      }
    }
  }
`;

export const ProductInfoWrapper = styled.section`
  position: sticky;
  top: 20px;
  z-index: 30;
  .product {
    &-new-shopper {
      margin-bottom: 16px;
      .flag {
        display: inline-block;
        font-weight: bold;
        font-size: 16px;
        color: #fff;
        line-height: 24px;
        border-radius: 4px;
        background-color: #c82314;
        padding: 0 6px;
      }
    }
    &-flash-sale {
      display: inline-flex;
      align-items: center;
      margin-bottom: 16px;
      .flag {
        font-weight: bold;
        font-size: 16px;
        color: #fff;
        line-height: 24px;
        border-radius: 4px;
        background-color: #e37200;
        padding: 0 6px;
      }
      img {
        border-radius: 4px 0 0 4px;
      }

      &-time {
        font-size: 16px;
        line-height: 20px;
        padding: 0 8px;
        color: #888b94;
      }
    }
  }
`;

export const SkuDetailWrapper = styled.div`
  /* .final-price-info {
    display: flex;
    height: 36px;
    align-items: center;
    cursor: pointer;
  } */
  .product {
    &-custom-rating {
      display: flex;
      gap: 4px;
      font-size: 16px;
      margin-right: 4px;
    }
    &-sku-auxiliary-info {
      gap: 8px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
    }

    &-sku-title {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 16px;
      overflow-wrap: break-word;
    }

    &-sku-best-seller {
      display: flex;
      /* align-items: flex-end; */
      line-height: 16px;
      font-size: 16px;
      font-weight: 700;
      // margin-bottom: 8px;

      .rank-text {
        /* font-weight: bold; */
        font-size: 14px;
        color: #b35b14;
        line-height: 18px;
        white-space: nowrap;
        margin-bottom: 0;
      }

      .category-text {
        font-size: 14px;
        font-weight: normal;
        color: #888b94;
        line-height: 18px;
        margin-left: 8px;
        cursor: pointer;
        // display: flex;
        // align-items: center;
        max-width: 300px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          color: var(--dp-hover-state-color);
          svg {
            path {
              stroke: var(--dp-hover-state-color);
            }
          }
        }
      }
      svg {
        margin-left: 4px;
        transform: rotate(-90deg);
      }
    }

    &-sku-score {
      display: flex;
      align-items: flex-end;
      line-height: 16px;
      font-size: 16px;
      font-weight: 700;
      // margin-bottom: 16px;

      .total-reviews {
        font-size: 12px;
        color: #888b94;
        margin-left: 8px;
        font-weight: normal;
        line-height: 15px;
      }
    }

    &-sku-price {
      display: flex;
      gap: 4px;
      align-items: end;
      height: 32px;
      margin-bottom: 2px;
      /* .promotion-frame {
        height: 100%;
        .promotion-icon {
          width: auto;
          height: 20px;
        }
      } */
      .opt-zone {
        display: flex;
        align-items: center;
        gap: 4px;
        position: relative;
        .frameText {
          font-size: 16px;
          color: #cc0c1c;
          font-weight: 500;
        }
      }
      /* &-origin {
        font-size: 24px;
      } */
      /* &-tag {
        height: 25px;
        font-size: 16px;
        color: #cc0c1c;
        font-weight: 500;
      } */
    }
    &-sku-tagIntegral {
      display: flex;
      max-height: 52px;
      align-items: center;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 4px;
      /* &-price-origin {}; */
      &-line {
        width: 1px;
        color: #c2c4cc;
        margin: 0 8px;
      }
      &-tag {
        /* height: 25px;
        font-size: 16px; */
        color: #cc0c1c;
        /* font-weight: 500; */
      }
    }
    &-sku-integral {
      /* height: 18px;
        font-size: 14px;
        line-height: 18px; */
      max-height: 24px;
      margin-bottom: 4px;
      color: var(--sys-Text-Secondary);
      display: flex;
      align-items: center;
      /* margin-bottom: 8px; */
      span {
        max-width: calc(100% - 20px);
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        text-overflow: ellipsis;
      }
      svg {
        margin-left: 4px;
        cursor: pointer;
      }
    }

    &-sku-klrana {
      height: 22px;
      font-size: 16px;
      line-height: 22px;
      display: inline-flex;
      font-weight: 500;
      align-items: center;
      margin-bottom: 24px;
      span {
        display: flex;
        align-items: center;
        cursor: pointer;
        b {
          font-weight: 700;
        }
        /* &:hover {
          color: var(--dp-hover-state-color);
          font {
            color: #1a1a1a;
            color: var(--dp-hover-state-color);
            b {
              color: var(--dp-hover-state-color);
            }
          }
        } */
      }
      svg {
        margin-left: 4px;
        cursor: pointer;
      }
    }

    &-sku-coupon {
      padding-right: 24px;
      margin-bottom: 16px;
      position: relative;
      padding-right: 30px;
      .expand-opt {
        position: absolute;
        right: 0;
        cursor: pointer;
        transition: transform 0.3s;
        &.expanded {
          transform: rotate(180deg);
        }
        &:hover {
          color: var(--dp-hover-state-color);
          svg {
            path {
              stroke: var(--dp-hover-state-color);
            }
          }
        }
      }
      .inner {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
    }

    &-coupon-type-1 {
      height: 20px;
      padding: 0 6px;
      line-height: 20px;
      border: 0.5px solid #ff0f2399;
      background: linear-gradient(90deg, rgba(255, 71, 93, 0.1) 0%, rgba(255, 15, 35, 0.1) 100%);
      color: #ff0f23;
      font-size: 12px;
      border-radius: 2px;
      cursor: pointer;
    }

    &-coupon-type-2 {
      display: flex;
      height: 20px;
      padding: 0 8px;
      line-height: 20px;
      border: 0.5px solid #ff0f2399;
      color: #ff0f23;
      font-size: 12px;
      border-radius: 2px;
      cursor: pointer;
      .column-1 {
        padding-right: 4px;
        border-right: 1px dashed #ff0f2399;
      }

      .column-2 {
        padding-left: 4px;
      }
    }

    &-sku-props {
    }
  }
  .comment-score-rating {
    margin-bottom: 0;
    .basic-font {
      align-items: flex-end;
    }
  }
  .comment-count {
    height: 12px;
    font-size: 14px;
    color: #888b94;
    line-height: 14px;
    margin-left: 4px;
    font-weight: normal;
    display: flex;
    align-items: center;
    cursor: pointer;
    svg {
      margin-left: 4px;
      transform: rotate(-90deg);
    }
    &:hover {
      color: var(--dp-hover-state-color);
      svg {
        path {
          stroke: var(--dp-hover-state-color);
        }
      }
    }
  }
  .sale-amount {
    font-weight: normal;
    font-size: 14px;
    color: #888b94;
    line-height: 14px;
  }
  .margin-left {
    margin-left: 4px;
  }
`;

export const KlranaDialogWrapper = styled.div`
  .klrana-dialog-content {
    font-size: 14px;
    line-height: 18px;
    text-align: left;
  }

  .klrana-dialog-btn {
    margin-top: 24px;
    width: 80px;
    height: 32px;
    font-size: 14px;
    line-height: 18px;
    position: absolute;
    right: 24px;
    bottom: 24px;
    text-align: center;
    color: #ffffff;
    background: #cc0c1c;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
  }
`;
export const SelectModelGroupWrapper = styled.div`
  .group {
    margin-bottom: 24px;

    .head {
      font-size: 16px;
      margin-bottom: 8px;
      line-height: 22px;
      font-weight: 500;
      span {
        font-weight: 600;
      }
    }

    .content {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      .item {
        display: flex;
        align-items: center;
        border: 1px solid #c2c4cc;
        border-radius: 4px;
        min-height: 36px;
        overflow: hidden;

        &.imgV1 {
          flex-direction: column;
          padding: 0;
          gap: 0;
          width: 80px;
          img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            padding: 2px;
          }
          .skuName {
            width: 100%;
            line-height: 26px;
            padding: 0 10px;
            font-weight: 500;
            text-align: center;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        &.text {
          padding: 4px 12px;
          &.active {
          }
        }

        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
        }
        //selected
        &.active {
          border: 1.5px solid #1a1a1a;
          background-color: #f4f4f4;
          &:not(.text) {
            .skuName {
            }
          }
        }
        &.noStock {
          position: relative;
          color: #c2c4cc;
          border: 1px dashed #c2c4cc;
          /* background: transparent !important; */
          .skuName {
            background-color: transparent !important;
          }
          &.active {
            border-width: 1.4px;
            border-style: solid;
            border-color: #1a1a1a;
            background-color: #ffffff;
          }
          &::before {
            content: '';
            position: absolute;
            inset: 0;
            background: rgba(255, 255, 255, 0.4);
            pointer-events: none;
            z-index: 1;
          }
        }
        &.disabled {
          position: relative;
          color: #c2c4cc;
          border: 1.4px dashed #e0e1e5;
          background-color: #0000000a;
          cursor: not-allowed;
          &.text {
            &:after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(
                to bottom right,
                transparent calc(50% - 1px),
                #c2c4cc calc(50% - 1px),
                #c2c4cc 50%,
                transparent 50%
              );
            }
          }
          &.imgV1 {
            &:after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 26px;
              background: linear-gradient(
                to left top,
                transparent calc(50% - 1px),
                #c2c4cc calc(50% - 1px),
                #c2c4cc 50%,
                transparent 50%
              );
            }
          }
        }
        &:hover {
          &:not(.disabled) {
            &:not(.active) {
              background-color: #f0f1f4;
              border-color: #c2c4cc;
              &:active {
                background: #e6e8ed;
              }
            }
            &.active {
              background-color: #e7e9ef;
              &:active {
                background: #dde1e8;
              }
            }
          }
          &.noStock {
            &:active {
              background: #e6e8ed;
            }
            background-color: #f0f1f4;
          }
        }
      }
    }
  }
`;

export const BuyOrAddToCarWrapper = styled.div`
  margin-bottom: 24px;
  padding-top: 8px;
  margin-top: -8px;
  background-color: #fff;
  position: sticky;
  bottom: 0;
  z-index: 10;
  .inner {
    display: flex;
    gap: 8px;
  }

  .btn {
    font-size: 16px;
    width: 228px;
    height: 48px;
    border-radius: 4px;
    line-height: 48px;
    text-align: center;
    font-weight: 700;

    &:hover {
      cursor: pointer;
    }
  }

  .add-cart {
    color: #ff0f23;
    background: #ffebf1;
  }

  .buy-now {
    color: #ffffff;
    background: linear-gradient(90deg, #ff475d 0%, #ff0f23 100%);
  }

  .disabled .btn {
    opacity: 0.5;
    cursor: no-drop;
  }
`;

export const AddressSelectorWrapper = styled.div`
  width: 100%;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;
  .intro {
    padding: 24px 8px 0;
    display: flex;
    gap: 8px;
    flex-direction: column;
  }
  .performance_info {
    padding: 24px 8px 0;
    display: flex;
    justify-content: space-around;
    .or_divider {
      display: flex;
      position: relative;
      padding: 0 16px;
      color: #888b94;
      font-size: 12px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 1px;
        height: 30%;
        background-color: #e0e1e5;
      }
      &:before {
        top: 0;
      }
      &:after {
        bottom: 0;
      }
    }
    .info {
      display: flex;
      align-items: center;
      flex: 1;
      flex-direction: column;
      font-size: 14px;
      justify-content: space-between;
      .info_icon {
        padding: 6px;
        background: #edeff2;
        border-radius: 100%;
      }
      .info_title {
        font-size: 16px;
        color: #1a1a1a;
        display: flex;
        align-items: center;
        flex-direction: column;
        .info_title_content {
          padding-top: 2px;
        }
      }
      .info_desc {
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #888b94;
        padding: 6px 0;
      }
    }
  }
  .update-postcode {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    line-height: 40px;
    border-radius: 6px;
    border: 1px solid #888b94;
    padding: 0 10px;
    color: #1a1a1a;
    font-size: 16px;
    .col {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      svg {
        margin-top: -2px;
      }
      strong {
        line-height: 22px;
        font-weight: 500;
      }
    }
    &:hover {
      cursor: pointer;
      background-color: #f0f1f4;
      &:active {
        background-color: #e5e7ed;
      }
      .arrow-right {
        svg {
          path {
            /* stroke: var(--dp-hover-state-color); */
          }
        }
      }
    }
    .arrow-right {
      transform: rotate(-90deg);
      svg {
        path {
          stroke: #1a1a1a;
        }
      }
    }
  }
`;
export const AssuranceWrapper = styled.div`
  .product {
    &-sku-assurance {
      width: 100%;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      margin-bottom: 16px;
      &.noBottomBorder {
        border-bottom: 0;
        padding-bottom: 0;
      }
      &:first-child {
        .accordion-summary {
          cursor: default;
        }
      }
    }
  }

  .accordion-summary {
    display: flex;
    font-weight: 600;
    position: relative;
    padding-right: 16px;
    align-items: center;
    word-break: break-all;
    font-size: 16px;
    line-height: 22px;
    p {
      flex: 1;
    }
    img {
      width: 20px;
      margin-right: 16px;
    }
    &:hover {
      cursor: pointer;
      text-decoration: underline;
      /* .arrow-wrapper {
        svg {
          path {
            stroke: var(--dp-hover-state-color);
          }
        }
      } */
    }
    .arrow-wrapper {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      cursor: pointer;
      transition: transform 0.3s;
      svg {
        path {
          stroke: #1a1a1a;
        }
      }
    }
    &.expanded {
      .arrow-wrapper {
        transform: translateY(-50%);
      }
    }
  }

  .accordion-title {
    /* font-family: Barlow; */
    font-family: Barlow Fix 50;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 32px;
  }

  .accordion-detail {
    font-size: 14px;
    line-height: 20px;
    .content {
      padding-top: 16px;
      white-space: pre-line;
      margin: 0;
    }
    color: #1a1a1a;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: space-between;
    overflow: hidden;
    transition: all 0.3s linear;
    .free {
      color: #269636;
      margin-left: 12px;
    }
    .green {
      color: #269636;
    }
  }

  .bold {
    font-weight: bold;
  }

  .bank-card {
    display: flex;
    gap: 8px;

    img {
      width: 42px;
      height: 24px;
    }
  }
`;

export const CategoryNavWrapper = styled.div`
  width: 752px;
  box-sizing: content-box;
  transition: height 0.3s linear;
  height: 0;
  ${(props: any) => {
    return (
      props['data-sticky'] &&
      css`
        position: fixed;
        top: 0;
        background-color: #fff;
        z-index: 100;
        overflow: hidden;
      `
    );
  }}
  ${(props: any) => {
    return (
      props['data-stickied'] &&
      css`
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
        overflow: visible;
        padding: 8px 0;
        height: 32px;
        box-sizing: content-box;
      `
    );
  }}
  &.recommend-nav {
    .cate-nav-list {
      font-size: 24px;
      height: 46px;
    }
  }
  .cate-nav-list {
    height: 32px;
    display: flex;
    font-size: 18px;
    color: #505259;
    gap: 24px;
    background-color: #fff;
  }

  .cate-nav-item {
    position: relative;
    line-height: 24px;

    &:hover {
      cursor: pointer;

      &:not(.active) {
        color: var(--dp-hover-state-color);
      }
    }

    &.active {
      color: #1a1a1a;
      font-weight: bold;

      &:after {
        content: '';
        position: absolute;
        width: 36px;
        height: 3px;
        border-radius: 1px;
        left: 50%;
        bottom: 0;
        background: #1a1a1a;
        transform: translateX(-50%);
      }
    }
  }
`;

export const DpRichContentWrapper = styled.div`
  h1 {
    font-size: 2em;
    font-weight: bold;
  }
  h2 {
    font-size: 1.5em;
    font-weight: bold;
  }
  h3 {
    font-size: 1.17em;
    font-weight: bold;
  }
  h4 {
    font-size: 1em;
    font-weight: bold;
  }
  h5 {
    font-size: 0.83em;
    font-weight: bold;
  }
  h6 {
    font-size: 0.67em;
    font-weight: bold;
  }
  padding-bottom: 6px;
  img {
    vertical-align: bottom;
  }
  table {
    max-width: 100%;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    box-sizing: border-box;
    border-collapse: collapse;
    * {
      box-sizing: border-box;
    }
    tbody,
    thead {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      tr th,
      tr td {
        border-bottom: 1px solid #d9d9d9;
        border-right: 1px solid #d9d9d9;
        padding: 3px 5px;
        min-height: 30px;
        height: 30px;
      }
      tr th {
        text-align: center;
        background-color: #f1f1f1;
      }
    }
  }
  ol {
    margin: 10px 0 10px 20px;
    li {
      list-style-type: decimal;
    }
  }
  ul {
    margin: 10px 0 10px 20px;
    li {
      list-style-type: disc;
    }
  }
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }
  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  pre code {
    display: block;
  }
  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bolder;
  }
  em {
    font-style: italic;
  }
  sup {
    vertical-align: super;
    font-size: smaller;
  }
  sub {
    vertical-align: sub;
    font-size: smaller;
  }
`;

export const ProductDetailWrapper = styled.div`
  word-break: break-word;
  overflow: auto;
  .brand-floor {
    position: relative;
    margin-bottom: 24px;
    font-size: 16px;
    .brand-title {
      font-size: 20px;
      color: var(--sys-Text-Primary);
      font-weight: bold;
      margin-bottom: 16px;
    }
  }
  .b-container {
    .text {
      color: rgba(80, 82, 89, 1);
      line-height: 20px;
      font-size: 16px;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
    img {
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
  .show {
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    &.see-more {
      width: 100%;
      height: 120px;
      background: linear-gradient(359.07deg, #ffffff 1.4%, rgba(255, 255, 255, 0) 99.8%);
    }
    &.see-less {
      position: unset;
      margin-top: 16px;
      svg {
        margin-top: 0;
        transform: rotate(180deg);
      }
    }
    .text {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: rgba(136, 139, 148, 1);
      line-height: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        margin-left: 4px;
      }
      &:hover {
        cursor: pointer;
        color: var(--sys-color-Primary800);
        svg {
          path {
            stroke: var(--sys-color-Primary800);
          }
        }
      }
    }
  }
  .title-box {
    margin-bottom: 16px;
    width: 100%;
    height: 26px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    justify-content: space-between;
  }

  .title-h-box {
    display: flex;
  }

  .title-h1 {
    margin-right: 16px;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    text-align: left;
    color: rgba(26, 26, 26, 1);
  }

  .title-h2 {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 26px;
    color: #1a1a1a;
    &:hover {
      text-decoration: underline;
    }
  }

  .allergy-health {
    margin-top: 16px;
    margin-bottom: 24px;

    .content {
      color: #505259;
    }
  }
  .product-des,
  .importantInfo,
  .speciafication {
    margin-bottom: 44px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e0e1e5;
  }
  .speciafication {
    .content {
      display: grid;
      font-size: 14px;
      line-height: 22px;
      grid-template-columns: fit-content(30%) auto;
      .grid-item {
        line-height: 22px;
        padding: 8px 0;
        &:nth-child(odd) {
          color: #888b94;
          margin-right: 16px;
        }
        &:nth-child(even) {
          color: #1a1a1a;
        }
      }
    }
  }
`;

export const CommonProductListWrapper = styled.section`
  margin-bottom: 32px;
  .title {
    line-height: 24px;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .product-card-wrapper {
    display: flex;
    gap: 16px;
    display: flex;
    flex-wrap: wrap;
  }
`;

export const CardWrapper = styled.div`
  width: 240px;

  .product {
    &-card {
      cursor: pointer;

      .image-wrapper {
        width: 240px;
        height: 240px;
        display: flex;
        margin-bottom: 12px;

        img {
          max-width: 240px;
          max-height: 240px;
          object-fit: contain;
        }

        ${imgMask}
      }

      &-name {
        line-height: 22px;
        font-size: 16px;
        margin-bottom: 4px;
        height: 44px;
        ${line2Overflow}
      }

      .promotion-tag {
        font-size: 12px;
        line-height: 16px;
        margin-right: 2px;
        color: #ffffff;
        display: inline-block;
        background: linear-gradient(90deg, #ff475d 0%, #ff0f23 100%);
        padding: 0 4px;
        border-radius: 2px;
        vertical-align: text-bottom;
      }

      .price-wrapper {
        display: flex;
        gap: 8px;
        align-items: end;
        height: 28px;
        margin-bottom: 4px;

        .real {
          font-size: 16px;
          font-weight: 700;
          color: #1a1a1a;
          line-height: 20px;

          .emphasize {
            font-size: 24px;
          }
        }

        .origin {
          color: #888b94;
          font-size: 12px;
          text-decoration: line-through;
        }
      }

      .other {
        position: relative;
        display: flex;
        align-items: center;

        .star-icon {
          line-height: 16px;
          width: 15px;
          height: 16px;
          padding-left: 17px;
          background: url('${StarImg.src}') no-repeat left center;
          background-size: 15px 15px;
        }

        .score {
          font-size: 16px;
          line-height: 16px;
        }

        .add-cart {
          position: absolute;
          right: 12px;
          bottom: 0;
          width: 32px;
          height: 32px;
          background: url('${AddCartImg.src}') no-repeat left center;
          background-size: 32px 32px;
        }
      }
    }
  }
`;

export const FollowWrapper = styled.div`
  width: 48px;
  height: 48px;
  position: absolute;
  background-size: 48px 48px;
  z-index: 66;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0000000a;
  border-radius: 6px;
  background: rgba(255, 255, 255);
  ${(props: any) => css`
    right: ${props.right || 12}px;
    top: ${props.top || 12}px;
  `}
  &:hover {
    &:not(.active) {
      background-size: 48px 48px;
      svg {
        path {
          stroke: #990915;
        }
      }
    }
  }

  &.active {
    background-size: 48px 48px;
    svg {
      path {
        fill: #cc0c1c;
        stroke: #cc0c1c;
      }
    }
  }
`;

export const HelpDetailWrapper = styled.div`
  overflow-y: auto;
  width: 100%;
  min-height: 100%;
  line-height: 1.5;

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  table,
  pre {
    margin: 10px 0;
    line-height: 1.5;
  }

  ul,
  ol {
    margin: 10px 0 10px 20px;
  }

  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }

  pre {
    code {
      display: block;
    }
  }

  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;

    td,
    th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 5px;
      min-height: 30px;
      height: 30px;
    }

    th {
      border-bottom: 2px solid #ccc;
      text-align: center;
      background-color: #f1f1f1;
    }
  }

  &:focus {
    outline: none;
  }

  img {
    cursor: pointer;

    &:hover {
      box-shadow: 0 0 5px #333;
    }
  }
`;

export const ServiceFloorWrapper = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;

  .service-title {
    font-family: Barlow Fix 50;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    padding-bottom: 12px;
    color: var(--sys-Text-Primary);
  }
`;
export const StoreFloorWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  & > svg,
  img {
    width: auto;
    height: 32px;
  }
  .visit_store_title {
    display: flex;
    font-size: 16px;
    line-height: 22px;
    align-items: center;
    &:hover {
      text-decoration: underline;
      svg {
        path {
          stroke: #1a1a1a;
        }
      }
    }
    svg {
      transform: rotate(-90deg);
      path {
        stroke: #505259;
      }
    }
  }
`;
export const ReserveTipsWrapper = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background-color: #deecff;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  margin-bottom: 8px;
`;
